<template>
  <div>
    <modal
      id="p-list-representation-select-file-modal"
      class="p-list-representation-select-file-modal"
      size="800px"
      :show.sync="show"
      :footer="false"
    >
      <div class="p-list-representation-select-modal-main row justify-content-center">

        <h3 class="p-list-representation-select-modal-title ">انتخاب فایل</h3>

        <div class="input-group ltr mt-3">
            <div class="input-group-prepend">
              <span class="input-group-text" id="inputGroupFileAddon01">انتخاب فایل</span>
            </div>

            <div class="custom-file">
              <input @change="selectedFile" type="file" class="custom-file-input" id="inputGroupFile01"
                aria-describedby="inputGroupFileAddon01">
              <label class="custom-file-label" for="inputGroupFile01"></label>
            </div>
        </div>

        <button @click="submitTransaction" type="button" class="btn btn-primary btn-blue btn-sm mt-4 p-list-representation-select-submit">ثبت پرداختها</button>
      </div>

    </modal>
  </div>
</template>

<script>
import modalSelectFile from './modalSelectFile.vue'


export default {
    name: 'modalSelectFile',
    props: {
      active                    : { type: [Boolean, Number], default: false },
    },

    data() {
      return {
        selectedFileBlob : {},
      }
    },

    computed: {
      show: {
        set(val) {
          this.$emit('update:active', !!val)
        },
        get() {
          return !!this.active
        }
      },
    },

    mounted () {
    },

    watch: {
      show(){
        this.selectedFileBlob = {};
      }
    },

    methods: {
      submitTransaction(){
        this.show = false;
        this.$emit('submitModalFile',this.selectedFileBlob);
      },

      selectedFile($event){
        const getBlob = $event.target.files;
        this.selectedFileBlob = getBlob;
      },

    },

}
</script>
